export default __webpack_public_path__ + "static/media/home-decor-img-13.b5a7dd86.png";